import { render, staticRenderFns } from "./WBindex.vue?vue&type=template&id=40b5b204"
import script from "./WBindex.vue?vue&type=script&lang=js"
export * from "./WBindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports